/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddJxModel
 */
export interface AddJxModel {
    /**
     * 
     * @type {string}
     * @memberof AddJxModel
     */
    jurisdictionId?: string;
}

export function AddJxModelFromJSON(json: any): AddJxModel {
    return AddJxModelFromJSONTyped(json, false);
}

export function AddJxModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddJxModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jurisdictionId': !exists(json, 'jurisdictionId') ? undefined : json['jurisdictionId'],
    };
}

export function AddJxModelToJSON(value?: AddJxModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jurisdictionId': value.jurisdictionId,
    };
}


